<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    />
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

// Parse and validate configuration using fail-fast Zod validation
// Universal RAW to WebP converter - supports 20+ camera RAW formats via LibRaw
const converterConfig = parseAndValidateConverterConfig('raw-to-webp-converter', 'RAW → WebP');

// Event handlers
function handleBatchCreated(batchId: string) {
  console.log('[RAW to WebP Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[RAW to WebP Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[RAW to WebP Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[RAW to WebP Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[RAW to WebP Converter] Credits updated:', credits);
}
</script>
